import type { ReactNode } from 'react'

type AlertProps = {
  children: ReactNode
}

export function Alert({ children }: AlertProps) {
  return (
    <div
      className="rounded-2xl border border-danger-border bg-danger-soft px-4 py-3 text-sm text-danger"
      role="alert"
    >
      {children}
    </div>
  )
}
